/**
 * Timeline rows for incognito investors show “Investor from {country}” with no id/name.
 * Only a revealed identity (name + id) may open a profile.
 */
export function isRevealedTimelineInvestor(investor: {
  investorId?: string;
  investorName?: string;
}): boolean {
  const name = investor.investorName?.trim();
  if (!investor.investorId?.trim() || !name) return false;
  return !/^(an?\s+)?investor from\s+/i.test(name);
}
